import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        height:auto; \n        width: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { rem } from 'polished';
import { media } from '~layout';
var Cell = styled.div.withConfig({
  displayName: "Cell",
  componentId: "sc-8ccj37-0"
})(["align-items:center;display:flex;height:", ";justify-content:", ";padding:", ";text-align:center;width:", ";", ""], rem(56), function (_ref) {
  var isLead = _ref.isLead;
  return isLead ? 'flex-start' : 'center';
}, rem(8), rem(48), media.sm(_templateObject(), function (_ref2) {
  var isLead = _ref2.isLead;
  return isLead ? rem(60) : rem(40);
}));
export default Cell;